import { render, staticRenderFns } from "./ToggleTeaser.vue?vue&type=template&id=2c3bdd63&"
import script from "./ToggleTeaser.vue?vue&type=script&lang=js&"
export * from "./ToggleTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports